// // // src/services/http.jsx
// // import axios from "axios";

// // const http = axios.create({
// //   baseURL: "https://sramidcard.in/api/",
// // });

// // http.interceptors.request.use((config) => {
// //   const user = JSON.parse(localStorage.getItem("user"));
// //   const token = user?.token || localStorage.getItem("token");

// //   if (token) {
// //     config.headers = config.headers || {};
// //     config.headers.Authorization = `Bearer ${token}`;
// //   }

// //   // 🟢 If sending FormData → DO NOT set Content-Type
// //   if (config.data instanceof FormData) {
// //     if (config.headers["Content-Type"]) {
// //       delete config.headers["Content-Type"];
// //     }
// //     return config;
// //   }

// //   // 🟢 For normal JSON requests only
// //   if (!config.headers["Content-Type"]) {
// //     config.headers["Content-Type"] = "application/json";
// //   }

// //   return config;
// // });

// // // Handle unauthorized
// // http.interceptors.response.use(
// //   (res) => res,
// //   (err) => {
// //     if (err?.response?.status === 401) {
// //       localStorage.removeItem("user");
// //       localStorage.removeItem("token");
// //       window.location.href = "/sign-in";
// //     }
// //     return Promise.reject(err);
// //   }
// // );

// // export default http;


// // src/services/http.jsx
// import axios from "axios";

// const http = axios.create({
//   baseURL: "https://sramidcard.in/api/",
// });

// http.interceptors.request.use((config) => {
//   const user = JSON.parse(localStorage.getItem("user"));
//   const token = user?.token || localStorage.getItem("token");

//   if (token) {
//     config.headers = config.headers || {};
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   // 🟢 FormData → let browser set boundary
//   if (config.data instanceof FormData) {
//     delete config.headers["Content-Type"];
//     return config;
//   }

//   // 🟢 JSON requests
//   config.headers["Content-Type"] =
//     config.headers["Content-Type"] || "application/json";

//   return config;
// });

// // 🔐 Handle 401 globally
// http.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     if (err?.response?.status === 401) {
//       localStorage.removeItem("user");
//       localStorage.removeItem("token");
//       window.location.href = "/sign-in";
//     }
//     return Promise.reject(err);
//   }
// );

// export default http;

import axios from "axios";

const http = axios.create({
  baseURL: "https://sramidcard.in/api/school/",
});

http.interceptors.request.use(
  (config) => {
    let user = null;

    try {
      const rawUser = localStorage.getItem("user");

      if (rawUser) {
        user = JSON.parse(rawUser);
      }
    } catch (error) {
      console.error("User Parse Error:", error);
    }

    const token =
      user?.token ||
      user?.access_token ||
      localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // If sending FormData -> delete Content-Type to let browser set multipart boundary
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    } else if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default http;

